// TOUR-5 — Sales Console walkthrough (RTO, checklist, follow-ups, notes).

import type { FireflyTourArtifact } from "../tourTypes";

export const SALES_CONSOLE_TOUR_ID = "tour-sales-console";

export const SALES_CONSOLE_TOUR: FireflyTourArtifact = {
  id: SALES_CONSOLE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "sales console tour",
    "how do i use the customer console",
    "customer console tour",
    "rto calculator walkthrough",
    "how do i use sales console",
    "show me the sales console",
    "rent to own calculator tour",
  ],
  bucketRelevance: ["sales"],
  requiredRoles: ["sales"],
  steps: [
    {
      id: "nav-sales-console",
      target: { mode: "leads", anchorId: "mode-nav-salesConsole", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "salesConsole",
      copy: {
        title: "Open Sales Console",
        body: "Your live-conversation tools live here — RTO estimates, follow-ups, and org notes. Tap Sales Console in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "activity-dock",
      target: { mode: "salesConsole", anchorId: "activity-dock-tab", scrollIntoView: true },
      copy: {
        title: "Your Firefly tab",
        body: "Firefly follows you in Sales Console too. Expand it for your daily checklist and quick Ask help.",
      },
      advanceOn: "next_button",
    },
    {
      id: "daily-checklist",
      target: { mode: "salesConsole", anchorId: "sc-daily-checklist", scrollIntoView: true },
      copy: {
        title: "Daily checklist",
        body: "Track today's sales tasks and ad logs from Firefly. Progress updates as you check items off — follow-up alerts link back here when something is due.",
      },
      advanceOn: "next_button",
    },
    {
      id: "follow-ups",
      target: { mode: "salesConsole", anchorId: "sc-follow-ups", scrollIntoView: true },
      copy: {
        title: "Follow-up queue",
        body: "Overdue and upcoming follow-ups surface at the top. Open a lead from a row when you are ready to continue the conversation.",
      },
      advanceOn: "next_button",
    },
    {
      id: "rto-calculator",
      target: { mode: "salesConsole", anchorId: "sc-rto-calc", scrollIntoView: true },
      copy: {
        title: "RTO calculator",
        body: "Enter cash price and down payment to show term estimates at the lot. Numbers are estimates only — admin configures the term table in org settings.",
      },
      advanceOn: "next_button",
    },
    {
      id: "sticky-notes",
      target: { mode: "salesConsole", anchorId: "sc-sticky-notes", scrollIntoView: true },
      copy: {
        title: "Sticky notes",
        body: "Org-wide reminders from trainers and owners appear here. Reps read them during conversations; trainers can edit when they have access.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "salesConsole", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Need a refresher on capture or opportunities? Ask Firefly anytime — tours can start from any Sales mode.",
      },
      advanceOn: "next_button",
    },
  ],
};
